import { Base } from "ui/Scripts/source/framework/base";
import { IPagePanel } from "../common/pagePanel";
import { CompanyMenuItem, ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { ISavedListFilter, SavedListFilter } from "../common/savedListFilter";
import { IWhistleBlowPageData, WhistleBlowPageData } from "./whistleBlowPageData";
import { WhistleBlowPagePanel } from "./whistleBlowPagePanel";
import { ISavedChartPanel, SavedChartPanel } from "../chart/savedChartPanel";

export interface IWhistleBlowPage extends IWhistleBlowPageData {
    canEditPermssions: boolean;
    maxAttachmentsTotalSize: number;
    validAdditionalPermissions: number[];
    panels: IPagePanel[];
    chartPanels: ISavedChartPanel[];
    companies: ICompanyMenuItem[];
    companyFilters: ISavedListFilter[];
    userFilters: ISavedListFilter[];
}

export class WhistleBlowPage extends WhistleBlowPageData implements IWhistleBlowPage {
    canEditPermssions: boolean;
    maxAttachmentsTotalSize: number;
    validAdditionalPermissions: number[];
    panels: WhistleBlowPagePanel[];
    chartPanels: SavedChartPanel[];
    companies: CompanyMenuItem[];
    companyFilters: SavedListFilter[];
    userFilters: SavedListFilter[];

    constructor();
    constructor(obj: IWhistleBlowPage);
    constructor(obj?: any) {
        super(obj);
        this.canEditPermssions = obj && obj.canEditPermssions || false;
        this.maxAttachmentsTotalSize = obj && obj.maxAttachmentsTotalSize || 0;
        this.validAdditionalPermissions = obj && obj.validAdditionalPermissions || [];
        this.panels = Base.getTypedArray(obj ? obj.panels : null, WhistleBlowPagePanel);
        this.chartPanels = Base.getTypedArray(obj ? obj.chartPanels : null, SavedChartPanel);
        this.companies = Base.getTypedArray(obj ? obj.companies : null, CompanyMenuItem);
        this.companyFilters = Base.getTypedArray(obj ? obj.companyFilters : null, SavedListFilter);
        this.userFilters = Base.getTypedArray(obj ? obj.userFilters : null, SavedListFilter);
    }
}
